import { config } from '../../config';
import { devToolComputedValueReplacer } from './devToolComputedValueReplacer';

/**
 * Returns the options object for the store devtool middleware.
 *
 * @param storeName - The name of the store.
 * @returns The options object for the store dev tool.
 */
export const devToolOptions = (storeName: string) => ({
  enabled: config.debug.devtools,
  name: storeName,

  // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#serialize
  serialize: {
    options: {
      true: true,
    },
    // allows for tracking of computed properties through devtools
    replacer: devToolComputedValueReplacer,
  },
});
